export default __webpack_public_path__ + "static/media/img2.297c08c1.webp";